import type { TFunction } from "i18next";
import { CircleCheckIcon, CirclePauseIcon, CirclePlayIcon } from "lucide-react";

import {
  SupportOrderFlowErrorCode,
  SupportOrderFlowStatus,
  SupportOrderFlowType,
} from "~/graphql/graphql.gen";

export const getGroupActionReasons = (t: TFunction) => [
  {
    value: SupportOrderFlowType.CommunicationAppUsers,
    label: t("group_action_reasons.communication_app_users"),
  },
  {
    value: SupportOrderFlowType.DeliveryDelay,
    label: t("group_action_reasons.shipping_delays"),
  },
  {
    value: SupportOrderFlowType.DeliveryDelayV2,
    label: t("group_action_reasons.shipping_delays"),
  },
  {
    value: SupportOrderFlowType.CreditCompensationSupplierCharged,
    label: t("group_action_reasons.credit_compensation_supplier_charged"),
  },
  {
    value: SupportOrderFlowType.ProductWrongDescription,
    label: t("group_action_reasons.product_description_error"),
  },
  {
    value: SupportOrderFlowType.ProductOutOfStock,
    label: t("group_action_reasons.product_out_of_stock"),
  },
  {
    value: SupportOrderFlowType.ProductOutOfStockShopify,
    label: t("group_action_reasons.product_out_of_stock_shopify"),
  },
  {
    value: SupportOrderFlowType.OrderCancellation,
    label: t("group_action_reasons.order_cancellation"),
  },
  {
    value: SupportOrderFlowType.OrderOptimizationPackaging,
    label: t("group_action_reasons.order_optimization_packaging"),
  },
  {
    value: SupportOrderFlowType.Other,
    label: t("group_action_reasons.other"),
  },
];

export const getGroupActionStatuses = (t: TFunction) => [
  {
    value: SupportOrderFlowStatus.Completed,
    label: t("group_action_statuses.completed"),
    color: "var(--color-green-600)",
    icon: CircleCheckIcon,
  },
  {
    value: SupportOrderFlowStatus.InProgress,
    label: t("group_action_statuses.in_progress"),
    color: "var(--color-yellow-600)",
    icon: CirclePlayIcon,
  },
  {
    value: SupportOrderFlowStatus.Pending,
    label: t("group_action_statuses.pending"),
    color: "var(--color-gray-600)",
    icon: CirclePauseIcon,
  },
];

export const getGroupActionErrors = (t: TFunction) => [
  {
    value: SupportOrderFlowErrorCode.OrderAlreadyCanceled,
    label: t("group_action_errors.order_already_cancelled"),
  },
  {
    value: SupportOrderFlowErrorCode.OrderFulfillmentNotUnfulfilled,
    label: t("group_action_errors.order_fulfillment_not_unfulfilled"),
  },
  {
    value: SupportOrderFlowErrorCode.OrderItemsNotFound,
    label: t("group_action_errors.order_items_not_found"),
  },
  {
    value: SupportOrderFlowErrorCode.OrderSaleIdMismatch,
    label: t("group_action_errors.order_sale_id_mismatch"),
  },
  {
    value: SupportOrderFlowErrorCode.OrderUnknown,
    label: t("group_action_errors.order_unknown"),
  },
];
